module.exports = __webpack_public_path__ + "img/after4.ebaf3029.png";